import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import usePlatformsData from './usePlatformsData';
import { useProject } from '../../../../../context/ProjectContext';
import { MEDIA_CONTENT_PLACEMENT, MEDIA_TYPES } from '../../../../../constants';

const usePlatformsOptions = ({
  mediaType: propMediaType = MEDIA_TYPES.IMAGE,
  placement = MEDIA_CONTENT_PLACEMENT.SINGLE,
}) => {
  const { actions } = useProject();

  const platforms = useSelector((state) => state.story.platforms);
  const { labels, icons, iconColors } = usePlatformsData();

  const loadedTypeRef = useRef(null);

  useEffect(() => {
    if (!propMediaType) {
      loadedTypeRef.current = null;
      return;
    }

    const cacheKey = `${propMediaType}:${placement}`;

    if (loadedTypeRef.current === cacheKey) {
      return;
    }

    loadedTypeRef.current = cacheKey;
    actions('getPlatformInfo', { type: propMediaType, placement });
  }, [actions, placement, propMediaType]);

  return useMemo(() => {
    if (!propMediaType) {
      return [];
    }

    return Object.entries(platforms).map(([platform, platformOptions]) => ({
      platform,
      icon: icons[platform],
      iconColor: iconColors[platform],
      label: labels[platform],
      options: platformOptions.map((option) => ({
        value: option.name,
        label: option.display,
      })),
    }));
  }, [platforms, icons, iconColors, labels, propMediaType]);
};

export default usePlatformsOptions;
